const sidebarWidth = '186px';
export const getSidebarWidth = () => `width: ${sidebarWidth}`;
export const getRoleListWidth = `width: calc(100% - ${sidebarWidth})`;
